import { Link } from 'react-router-dom';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-[#F5F2EE] border-b border-[#1C1C1C]/8">
        <div className="max-w-7xl mx-auto px-8 md:px-14 py-16 md:py-24">
          <nav className="flex items-center gap-2 text-xs text-[#1C1C1C]/35 mb-8">
            <Link to="/" className="hover:text-[#ec3145] transition-colors cursor-pointer">მთავარი</Link>
            <i className="ri-arrow-right-s-line text-[10px]"></i>
            <span className="text-[#1C1C1C]/55">დაბრუნების პოლიტიკა</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-[#1C1C1C] tracking-tight mb-4">
            დაბრუნების პოლიტიკა
          </h1>
          <p className="text-[#1C1C1C]/45 text-base md:text-lg max-w-2xl">
            ჩვენი მიზანია თქვენი სრული კმაყოფილება. გთხოვთ, გაეცნოთ ჩვენს დაბრუნების პირობებს.
          </p>
          <p className="text-xs text-[#1C1C1C]/25 mt-6">ბოლო განახლება: 27 აპრილი, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-8 md:px-14 py-16 md:py-24">
        <div className="prose prose-lg max-w-none">
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">1. ზოგადი პრინციპები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              Phoenix Georgia ეძღვნება მომხმარებლის კმაყოფილებას. თუ რაიმე მიზეზით არ ხართ კმაყოფილი შეძენილი პროდუქტით, გთხოვთ დაგვიკავშირდეთ და ჩვენ ყველაფერს გავაკეთებთ სიტუაციის გასწორებისთვის.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ყველა დაბრუნების მოთხოვნა განიხილება ინდივიდუალურად, პროდუქტის ტიპის, მდგომარეობისა და შეძენის თარიღის მიხედვით. ჩვენ ვიტოვებთ უფლებას, უარი ვთქვათ დაბრუნებაზე, თუ პროდუქტი არ აკმაყოფილებს ამ პოლიტიკის მოთხოვნებს.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">2. დაბრუნების ვადა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              პროდუქტის დაბრუნება შესაძლებელია შეძენის თარიღიდან <strong className="text-[#1C1C1C]/75">14 კალენდარული დღის</strong> განმავლობაში. დაბრუნების მოთხოვნა უნდა გაკეთდეს ამ ვადის განმავლობაში.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              სპეციალური შეკვეთით მომზადებული ან მორგებული პროდუქტები (custom orders) არ ექვემდებარება სტანდარტულ დაბრუნებას, გარდა იმ შემთხვევისა, როდესაც პროდუქტი არის დეფექტური ან არ შეესაბამება შეკვეთის სპეციფიკაციას.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">3. დაბრუნების პირობები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              პროდუქტის დასაბრუნებლად უნდა შესრულდეს შემდეგი პირობები:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>პროდუქტი უნდა იყოს ორიგინალ მდგომარეობაში — გამოუყენებელი, დაზიანების გარეშე</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>პროდუქტი უნდა იყოს ორიგინალ შეფუთვაში (თუ შესაძლებელია)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>უნდა წარმოადგინოთ შეძენის დამადასტურებელი დოკუმენტი (ჩეკი, ინვოისი ან შეკვეთის დადასტურება)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>პროდუქტი არ უნდა იყოს მონტაჟზე დაყენებული ან დამუშავებული</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">4. არ ექვემდებარება დაბრუნებას</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              შემდეგი პროდუქტები არ ექვემდებარება დაბრუნებას (გარდა დეფექტის შემთხვევისა):
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>გაჭრილი ან მორგებული მასალები (მაგალითად: გაჭრილი ფილები, პარკეტი)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>გახსნილი ქიმიური პროდუქტები (წებო, ლაქი, საფარი)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>სპეციალური შეკვეთით მომზადებული პროდუქტები</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>პროდუქტები, რომლებიც მონტაჟზე უკვე დაყენებულია</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>პროდუქტები, რომლებიც დაზიანებულია არასწორი შენახვის ან გამოყენების შედეგად</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">5. დაბრუნების პროცესი</h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">მოთხოვნის გაგზავნა</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">დაგვიკავშირდით ტელეფონით ან ელფოსტით და მოგვაწოდეთ შეკვეთის ნომერი და დაბრუნების მიზეზი.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">გადამოწმება</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">ჩვენი გუნდი გადაამოწმებს მოთხოვნას და დაგიკავშირდებათ 1-2 სამუშაო დღის განმავლობაში.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">პროდუქტის დაბრუნება</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">დაბრუნების დადასტურების შემდეგ, პროდუქტი უნდა დაბრუნდეს ჩვენს ოფისში ან შეთანხმებულ მისამართზე.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-[#ec3145] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">4</div>
                <div>
                  <h4 className="text-sm font-bold text-[#1C1C1C] mb-1">გადახდის დაბრუნება</h4>
                  <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">პროდუქტის მიღებისა და შემოწმების შემდეგ, გადახდა დაბრუნდება 5-7 სამუშაო დღის განმავლობაში იმავე მეთოდით, რომელიც გამოიყენეთ შეძენისას.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">6. დეფექტური პროდუქტები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თუ მიიღეთ დეფექტური ან დაზიანებული პროდუქტი, გთხოვთ, დაგვიკავშირდეთ <strong className="text-[#1C1C1C]/75">48 საათის</strong> განმავლობაში მიწოდების თარიღიდან. ჩვენ უფასოდ შევცვლით დეფექტურ პროდუქტს ან დაგიბრუნებთ თანხას.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              დეფექტის შემთხვევაში, გთხოვთ, გადმოგვიგზავნოთ ფოტო ან ვიდეო დოკუმენტაცია, რათა დავადასტუროთ პრობლემა და სწრაფად მოვაგვაროთ ის.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">7. კონტაქტი</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              დაბრუნების მოთხოვნისთვის ან კითხვებისთვის გთხოვთ, დაგვიკავშირდეთ:
            </p>
            <div className="bg-[#F5F2EE] rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ელფოსტა</p>
                    <a href="mailto:info@phoenix.ge" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">info@phoenix.ge</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ტელეფონი</p>
                    <a href="tel:+995599872020" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">+995 599 87 20 20</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">სამუშაო საათები</p>
                    <p className="text-sm text-[#1C1C1C]/70">ორშ–შაბ: 09:30–19:30</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}